import { useEffect, useState } from 'react';

import styles from './styles.module.css';
import { faNum } from '@/functions/formats';
import { useLocale } from 'next-intl';
import MainIcons from '@/icons/main';
import CarSwitcherBox from './CarSwitcherBox';
import MoreBox from '@/components/general/MoreBox';
import { Car } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';
import PlateBadge from './PlateBadge';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import Api from '@/api';

export function CarSwitcher() {
  const locale = useLocale();
  const { activeCar, setActiveCar } = useLayoutContext();
  const [platesCount, setPlatesCount] = useState(0);
  let sample = {
    plate: TransformPlateNumber('ایران ۸۸ - ۴۱۴ ج ۸۷'),
    name: 'پریا رحیمی',
    id: 1,
  };
  // const cars = Array.from({ length: 4 }, (_, index) => ({
  //   ...sample,
  //   id: index + 1,
  // }));
  const [cars, setCars] = useState([]);

  useEffect(() => {
    Api.usersPlateList({ params: { start: 0, limit: 30 } })
      .then((res) => {
        console.log('count====', res);
        setCars(
          res?.data?.response?.map((d: any) => {
            return {
              ...d,
              name: d?.user?.display_name,
              plate: TransformPlateNumber(d?.license_plate),
            };
          }),
        );
        setPlatesCount(res?.data?.count);
      })
      .catch((err) => {
        console.error('usersPlateList failed:', err);
      });
  }, []);
  console.log('cars====', cars);
  return (
    <div className={styles.wrap}>
      <MoreBox
        activeStyle={`activeMoreBoxButton ${styles.activeButton}`}
        icon={<PlateBadge car={activeCar} />}
        id={'defaultCar'}
        selected={locale}
        boxClassName={`${styles.menu} ${Number(process.env.version) > 1 && styles.menuwithbasket}`}
      >
        <CarSwitcherBox
          platesCount={platesCount}
          cars={cars}
          activeCar={activeCar}
          setActiveCar={setActiveCar}
        />
      </MoreBox>
    </div>
  );
}
